export default __webpack_public_path__ + "static/media/colizeum_banner.8efd8df0.jpeg";